import React, {ReactElement, Component, Dispatch, SetStateAction, useContext} from 'react';
import {Menu} from 'antd';
import {FormattedMessage} from 'react-intl';
import {withRouter} from "react-router-dom";

// 全局变量
import {ContentSidebarSelectedContext} from '../contexts/content-sidebar-selected';
import {ContentSidebarToggleContext} from  '../contexts/content-sidebar-toggle';

// image
import { workspace_icon_dark_blue } from '../../../img';

const ContentSidebar = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)>=>{

    const {menuData} =props,
        set_content_sidebar_selected: Dispatch<SetStateAction<string>> = useContext(ContentSidebarSelectedContext)[1],
        content_sidebar_toggle: boolean = useContext(ContentSidebarToggleContext)[0];

    return(
        <div className={`content-sidebar ${content_sidebar_toggle&&'sidebar-show'}`}>
            <div className="content-sidebar-logo">
                <img src={workspace_icon_dark_blue} alt="" />
            </div>
            <div className="content-sidebar-menu">{
                menuData && <Menu
                    defaultSelectedKeys={[menuData.selected]}
                    mode={'inline'}
                    theme={'dark'}
                    onSelect={(key: any)=> {set_content_sidebar_selected(key.key); sessionStorage.setItem('content_sidebar_selected', key.key)}}
                >{menuData.list.map((item: any)=>(
                    <Menu.Item key={item.key}>
                        <span><FormattedMessage id={item.name}/></span>
                    </Menu.Item>
                ))
                }</Menu>
            }</div>
        </div>
    )
};

export default withRouter(ContentSidebar);
